// @ts-nocheck
import Moment from 'jalali-moment'
import {io} from "socket.io-client"
import {CookieRef, useCookie as useMainCookie} from "#app"
import {getAppCode, getBaseUrl, useGet} from "~/composables/fetch"


export const logger = (...args: any) => console.log('logger=>>>', ...args)
export const moment = Moment
export const s2n = (string: string | number) => (string + '').replace(/[^\d.]|\.\./ig, '')
export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

export const KMapper = (num) => Number(num) > 10e9 ? toLocal(Number(num) / 10e9, 2) + 'T'
	: Number(num) > 10e6 ? toLocal(Number(num) / 10e6, 2) + 'M'
		: Number(num) > 10e3 ? toLocal(Number(num) / 10e3, 2) + 'K'
			: Number(num) + ''

export const p2e = (string: string) => string
	.replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString())
	.replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d).toString())

export const toLocal = (number: number | string, decimal = 8) => {
	//purify number
	number = number + ''
	if (number === '.') {
		if (decimal)
			return '0.'
		else
			return ''
	}

	if (number.startsWith('-'))
		return 0

	if (number.toLowerCase().includes('e')) {
		if (parseFloat(number) < 1.0e-6) {
			//zero numbers
			return parseFloat(number)
		} else if (parseFloat(number) > 1.0e+20) {
			return '∞'
		} else
			number = parseFloat(number) + ''
	}

	number = p2e(number).replace(/[^\d.]|\.{2}|,/ig, '')
	if (number.includes('.')) {
		number = number.split('.')[0] + '.' + (number.split('.')[1] || '')
	}

	if (parseFloat(number)) {
		//separate number
		const int = parseFloat(number.split('.')[0]).toLocaleString('en')
		if (number.includes('.') && decimal) {
			return int + '.' + (number.split('.')[1].slice(0, decimal) || '')
		} else {
			return int
		}
	} else {
		return number
	}

}
export const copyData = async (string: string) => {
	const {$toast} = useNuxtApp()
	await navigator.clipboard.writeText(string)
	$toast.success('Copied :)')
}
export const mapper = (data: Record<string, any>, map: Record<string, any>, keys: string[] = _keys(map)) => {
	let value: Record<string, any> = {}
	const mapKeys = Object.keys(map)
	for (const key of keys) {
		const v = _get(data, key)
		_set(value, key, v)
	}
	for (const key of mapKeys) {
		// let overview = keys.indexOf(key)
		const v = _has(data, key) && _get(map, [key, 'handler'])?.(data[key]) || _get(data, key)
		_set(value, map[key]?.label || key, v)
	}
	return value
}

export function getDistanceFromLatLonInKm(lat1: number, lon1: number, lat2: number, lon2: number) {
	const R = 6371; // Radius of the earth in km
	const dLat = deg2rad(lat2 - lat1);  // deg2rad below
	const dLon = deg2rad(lon2 - lon1);
	const a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
		Math.sin(dLon / 2) * Math.sin(dLon / 2)
	;
	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	// Distance in km
	return R * c;
}

export function deg2rad(deg: number) {
	return deg * (Math.PI / 180)
}

export const isoToNormal = (time: string) => {
	return moment(time).locale('fa').format('jDD jMMMM | HH:mm')
}
export const isoToMonth = (time: string) => {
	return moment(time).locale('fa').format('jMMMM')
}
export const isoToDateTime = (time: string) => {
	return moment(time).locale('en').format('dd, DD MMM YYYY hh:mm')
}
export const isoToDate = (time: string) => {
	return moment(time).locale('fa').format('jYYYY/jMM/jDD')
}
export const isoToTime = (time: string) => {
	if (!time) return '—'
	const timeStr = String(time).trim()
	if (/^\d{2}:\d{2}(:\d{2})?$/.test(timeStr)) {
		const m = moment(timeStr, ['HH:mm', 'HH:mm:ss'])
		if (m.isValid()) {
			return m.locale('fa').format('HH:mm')
		}
		return timeStr.slice(0, 5)
	}
	const m = moment(timeStr)
	if (m.isValid()) {
		return m.locale('fa').format('HH:mm')
	}
	return '—'
}

const toPersianDigits = (value: string | number) => String(value).replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[Number(d)])

/**
 * Formats a configured court slot from its canonical label. When old records
 * do not have a label, durationMinutes is applied to the stored start time.
 */
export const formatSlotRange = (slot: {label?: string | null, datetime?: string | null, durationMinutes?: number | null} | null | undefined) => {
	if (!slot) return '—'
	const label = String(slot.label || '').trim()
	const range = label.match(/(\d{1,2})(?::(\d{2}))?\s*[-–—تا]+\s*(\d{1,2})(?::(\d{2}))?/)
	if (range) {
		const compact = (hour: string, minute?: string) => minute && minute !== '00'
			? `${Number(hour)}:${minute}`
			: String(Number(hour))
		return toPersianDigits(`${compact(range[1], range[2])}–${compact(range[3], range[4])}`)
	}
	if (label) return toPersianDigits(label)
	if (!slot.datetime) return '—'

	const start = moment(slot.datetime)
	if (!start.isValid()) return '—'
	const end = start.clone().add(Number(slot.durationMinutes) || 60, 'minutes')
	const compact = (value: any) => value.minutes() === 0 ? value.format('H') : value.format('H:mm')
	return toPersianDigits(`${compact(start)}–${compact(end)}`)
}
export const isoToDayOfWeek = (time: string) => {
	return moment(time).locale('fa').format('ddd')
}
export const isoToChatName = (time: string) => {
	return moment(time).locale('fa').format('jDD jMMMM hh:mm ')
}

export const isoToStandard = (time: string) => {
	return moment(time).locale('fa').format('MMM DD,YYYY hh:mmA')
}
export const dataToRange = (data: any[] | undefined): [string, string] => [isoToStandard(data?.[0]?.createdAt), isoToStandard(data?.[data?.length - 1]?.createdAt)]

export const subIsoDate = (du: string): string => moment().subtract(du.split(' ')[0] as DurationInputArg1, du.split(' ')[1] as DurationInputArg2).toISOString()

export const isExpire = (time) => moment(time).isBefore(moment())

export const remainToExpire = (timestamp, time: String) => {
	const diff = Math.round(moment(time).diff(moment(timestamp)) / 1000)
	const day = Math.floor(diff / (24 * 3600))
	const hour = Math.floor(diff % (24 * 3600) / 3600)
	const minute = Math.round(diff % 3600 / 60)
	const second = Math.round((diff % 3600) % 60)
	return [`${day}d`, `${hour}h`, `${minute}m`, `${second}s`]
}

export const useSocketIo = () => {
	const socket = io(getBaseUrl(), {
		extraHeaders: {
			authorization: useAppCookie('token').value || '',
			'app-code': getAppCode()
		},
		autoConnect: false
	});
	onBeforeUnmount(() => {
		socket.disconnect()
	})
	return socket
}
export const watchSocket = (socket, joinObject: SocketJoinObject, dataHandler, loading = ref(false), initHandler = async () => {
}) => {
	console.log(`watch on => ${joinObject.model}.${joinObject.coll}: ${joinObject.value}`)
	socket.on('connect', async () => {
		await initHandler?.()
		console.log('connect/reconnect', Date.now(), `${joinObject.model}.${joinObject.coll}: ${joinObject.value}`)
		await socket.emitWithAck('join', joinObject)
		loading.value = false
	})
	socket.on('data', dataHandler)
	socket.connect()
}

export const lastAct = (time: string) => {
	const {t} = useI18n()
	const diff = computed(() => Math.round(moment().diff(moment(time)) / 1000))
	const day = Math.floor(diff.value / 86400)
	const hour = Math.floor(diff.value / 3600)
	const minute = Math.round(diff.value / 60)

	if (day < 8) {
		if (hour < 24) {
			if (minute < 60)
				return minute + ' ' + t('min ago')
			else return hour + ' ' + t('h ago')
		} else return day + ' ' + t('d ago')
	} else return isoToDate(time)
}

export const setMeta = (data: MetaData) => {
	const metaData = useState<MetaData>('meta-data')
	metaData.value = data
}

export const encrypt = (text, passphrase) => {
	return AES.encrypt(text, passphrase).toString();
}

export const decrypt = (ciphertext, passphrase) => {
	const bytes = AES.decrypt(ciphertext, passphrase);
	try {
		return bytes.toString(enc);
	} catch (e) {
		return ''
	}
}

export const useWallets = async (isActive: Boolean | undefined = undefined): Promise<RemovableRef<Wallet[]>> => {
	const userId = useAppCookie('userId')
	if (!userId.value) {
		console.error('No userId found, cannot fetch wallets')
		return useLocalStorage<Wallet[]>('wallet', [])
	}

	const wallet = useLocalStorage<Wallet[]>('wallet', [])
	// Wallets are created server-side (client-side POST /wallet is blocked); this is idempotent.
	const {result} = await usePost<Wallet[]>('/wallet/ensure', {})
	if (!Array.isArray(result)) return wallet
	const wallets = result
	wallet.value = isActive === undefined ? wallets : wallets.filter((e: any) => e?.coin?.active === isActive)

	return wallet
}

export const scoreRating = (score: number, numQuestions = 7) => {
	const minScore = numQuestions * 1
	const maxScore = numQuestions * 3
	const percent = Math.min(Math.max(20 + ((score - minScore) * 60) / (maxScore - minScore), 20), 80)
	return Number((percent / 10).toFixed(1))
}

export const LEVEL_ASSESSMENT_SPORT_SLUGS = ['padel', 'paddle']

/** Returns the supported sport's score, or null for a genuinely unknown level. */
export const userLevelScore = (user: any): number | null => {
	const profiles = Array.isArray(user?.sportProfiles) ? user.sportProfiles : []
	const supported = profiles.find((profile: any) =>
		LEVEL_ASSESSMENT_SPORT_SLUGS.includes(String(profile?.sport?.slug || '').toLowerCase())
		&& Number(profile?.score) > 0
	)
	if (supported) return Number(supported.score)

	return null
}

export const userLevelRating = (user: any): number | null => {
	const score = userLevelScore(user)
	return score == null ? null : scoreRating(score)
}

export const rating = (comment) => {
	const comments = comment;
	const average = comments?.length > 0
		? comments.reduce((acc, item) => acc + item.number, 0) / comments.length
		: 0;
	return average.toFixed(1)
}

export const formatNumber = (value: number) => {
	if (value == null) return "";
	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
export const truncateText = (text: string, maxLength: number) => {
	return text?.length > maxLength ? text?.slice(0, maxLength) + '...' : text;
};

export const useAppCookie = <T = string>(
	name: string,
	options: UseCookieOptions<T> = {}
): CookieRef<T> => {
	const config = useRuntimeConfig()
	if (config.public.isApp) {
		return useLocalStorage<T>(name, options.default as T)
	} else {
		return useMainCookie<T>(name, options)
	}
}
